// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"a51397ca","158":"900c7058","661":"ae7ee434","815":"308e8f2e","899":"ff05f32b"}[chunkId] + ".chunk.css";
};